// @ts-strict-ignore
import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { TooltipService } from './tooltip.service';
import { TooltipConfig } from './types';
import { isEqual } from 'lodash-es';

@Directive({ selector: '[appTooltip]', standalone: true })
export class TooltipDirective implements OnInit, OnChanges, OnDestroy {
  @Input('appTooltip') config: TooltipConfig;
  @Input() tipOrigin: ElementRef;

  private _eventListeners = [
    ['mouseenter', this._show.bind(this)],
    ['mouseleave', this._hide.bind(this)],
    ['mousedown', this._hide.bind(this)],
    ['focusin', this._show.bind(this)],
    ['focusout', this._hide.bind(this)],
  ];

  constructor(
    private _elementRef: ElementRef<HTMLElement>,
    private _tooltipService: TooltipService
  ) {}

  ngOnInit() {
    this._setup();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      isEqual(changes.config?.currentValue, changes.config?.previousValue) &&
      isEqual(changes.tipOrigin?.currentValue, changes.tipOrigin?.previousValue)
    ) {
      return;
    }
    if (this._tooltipService.isVisible) {
      this._show();
    }
  }

  ngOnDestroy() {
    this._teardown();
  }

  private _hide() {
    this._tooltipService.hide();
  }

  private _setup() {
    if (this._elementRef) {
      this._eventListeners.forEach((l) => this._elementRef.nativeElement.addEventListener(l[0], l[1]));
    }
  }

  private _show() {
    this._tooltipService.show(this.tipOrigin ?? this._elementRef, this.config);
  }

  private _teardown() {
    this._eventListeners.forEach((l) => this._elementRef?.nativeElement?.removeAllListeners(l[0]));
  }
}
